import { FC, KeyboardEvent, useEffect, useState } from "react";
import Input from "~/components/Input";

type PriceRangeValues = {
  from?: number;
  to?: number;
}

const transformPriceRange = (priceRange?: string): PriceRangeValues | undefined => {
  if (!priceRange) return { from: undefined, to: undefined }
  const [from, to] = priceRange.split('_').map(Number);
  return { from, to };
}

const RadioCustom: FC<{
  onChange: (priceRange?: OptionAggregation['value']) => void;
  value?: OptionAggregation['value'];
  loading?: boolean;
}> = ({ onChange, value, loading }) => {
  const [priceRange, setFilter] = useState<PriceRangeValues | undefined>();

  useEffect(() => {
    setFilter(transformPriceRange(value));
  }, [value])

  const handleChangePrice = (priceRange?: { from?: number; to?: number }) => {
    setFilter(priceRange);
  }

  const handleCompletedInput = (priceRange?: { from?: number; to?: number }) => {
    if (!priceRange) return onChange(undefined)
    if (priceRange.from !== undefined && priceRange.to !== undefined) {
      onChange(`${priceRange.from}_${priceRange.to}`);
    }
  }

  const handleEnter = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleCompletedInput(priceRange);
    }
  }

  const handleInputChange = (field: 'from' | 'to') => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    handleChangePrice({ ...priceRange, [field]: isNaN(value) ? 0 : value });
  };

  const { from, to } = priceRange || {}

  return (
    <div className="flex flex-col gap-3">
      {/* <div className="py-3">
          <Slider
            min={0}
            max={200}
            step={1}
            value={[from, to]}
            onChange={(v: any) => handleChangePrice({ from: v[0], to: v[1] })}
            onChangeComplete={(v: any) => handleCompletedInput({ from: v[0], to: v[1] })}
            disabled={loading}
          />
        </div> */}
      <div className="flex gap-2 items-center">
        <Input
          prefix="$"
          type="number"
          value={(from === 0 || !!from) ? from?.toString() : ''}
          onChange={handleInputChange('from')}
          onBlur={(e) => handleCompletedInput({ ...priceRange, from: Number(e.target.value) })}
          onKeyDown={handleEnter}
          disabled={loading}
          placeholder="Low"
          min={0}
        />
        <div className="w-[26px] h-[1px] bg-[#D3D3D3] shrink-0" />
        <Input
          prefix="$"
          type="number"
          value={(to === 0 || !!to) ? to?.toString() : ''}
          min={0}
          onChange={handleInputChange('to')}
          onBlur={(e) => handleCompletedInput({ ...priceRange, to: Number(e.target.value) })}
          onKeyDown={handleEnter}
          disabled={loading}
          placeholder="High"
        />
      </div>
    </div>
  );
};

export default RadioCustom;
